var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 50 50",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      pointerEvents: "none",
      display: "block",
      width: "100%",
      height: "100%"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 28.875 0 A 1.0001 1.0001 0 0 0 28.8125 0.03125 L 0.8125 5.34375 A 1.0001 1.0001 0 0 0 0 6.34375 L 0 43.65625 A 1.0001 1.0001 0 0 0 0.8125 44.65625 L 28.8125 49.96875 A 1.0001 1.0001 0 0 0 30 49 L 30 44 L 47 44 C 48.093063 44 49 43.093063 49 42 L 49 8 C 49 6.9069372 48.093063 6 47 6 L 30 6 L 30 1 A 1.0001 1.0001 0 0 0 28.875 0 z M 28 2.1875 L 28 6.53125 A 1.0043849 1.0043849 0 0 0 28 7.40625 L 28 42.8125 A 1.0001 1.0001 0 0 0 28 43.21875 L 28 47.8125 L 2 42.84375 L 2 7.15625 L 28 2.1875 z M 30 8 L 47 8 L 47 42 L 30 42 L 30 37 L 34 37 L 34 35 L 30 35 L 30 29 L 34 29 L 34 27 L 30 27 L 30 22 L 34 22 L 34 20 L 30 20 L 30 15 L 34 15 L 34 13 L 30 13 L 30 8 z M 36 13 L 36 15 L 44 15 L 44 13 L 36 13 z M 6.6875 15.6875 L 12.15625 25.03125 L 6.1875 34.375 L 11.1875 34.375 L 14.4375 28.34375 C 14.6635 27.76175 14.814 27.31825 14.875 27.03125 L 14.90625 27.03125 C 15.03625 27.63925 15.15925 28.05525 15.28125 28.28125 L 18.53125 34.375 L 23.5 34.375 L 17.75 24.9375 L 23.34375 15.6875 L 18.65625 15.6875 L 15.6875 21.21875 C 15.4005 21.93975 15.19775 22.51 15.09375 22.875 L 15.0625 22.875 C 14.8975 22.266 14.709 21.72425 14.5 21.28125 L 11.8125 15.6875 L 6.6875 15.6875 z M 36 20 L 36 22 L 44 22 L 44 20 L 36 20 z M 36 27 L 36 29 L 44 29 L 44 27 L 36 27 z M 36 35 L 36 37 L 44 37 L 44 35 L 36 35 z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.54a6b690b355b9a440085fa96e45ab41.svg";
export { ForwardRef as ReactComponent };